document.addEventListener("DOMContentLoaded", function(event) {
  let el = document.querySelector('.mobile-opener__holder');

  let link = document.querySelector('.no-click');
  if (link) {
    link.onclick = function(e) {
      e.preventDefault();
    }
  }

  el.onclick = function() {
    el.parentElement.classList.toggle('active');
    document.body.classList.toggle('disable-body')
  }

  const headers = document.getElementsByClassName("mobile-menu__second-level__link");

  for (let i = 0; i < headers.length; i++) {
    let siblingElement = headers[i].parentElement.querySelector('.mobile-menu__third-level');
    let link = headers[i].getAttribute('data-link');
    
    headers[i].addEventListener("click", () => {
      if (siblingElement == null){
        window.location = link;
      }else{
        if (siblingElement.parentElement.classList.contains("content-transition")) {
          siblingElement.parentElement.classList.remove("content-transition");
        }
        else {
          siblingElement.parentElement.classList.add("content-transition");
        }
      }
    });
  }
})

document.addEventListener("DOMContentLoaded", function() {
  let mobileMenu = document.querySelector(".mobile-menu");
  let menuItems = mobileMenu.querySelectorAll(".mobile-menu__item");

  menuItems[0].style.padding = "0";

  menuItems.forEach( item => {
    if( item.innerHTML.trim() == ""){
      item.style.display = "none";
    }
  })
});
